import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { saveAs } from 'file-saver';
// @mui
import { Typography, Box, Stack, TextField, Button, Modal, IconButton, Container } from '@mui/material';

// Icons
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import VisibilityIcon from '@mui/icons-material/Visibility';
import BlockIcon from '@mui/icons-material/Block';

import CalendarMonth from '@mui/icons-material/CalendarMonth';

// Stepper
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

// api
import { getFluxogramas, getAnexos, getUnoAnexo, deleteUnoAnexo } from '../../api';
import ModalMensagem from '../../ModalMensagem';
import ModalAtividadade from '../../ModalAtividade';
import NewOsForm from '../NewOs/NewOsForm';

import { enviaMensagem } from '../../apiWpp';
import ModalConfirmacao from '../../ModalConfirmacao';
import ModalAddAnexo from '../../ModalAddAnexo';
import Agendamento from '../Modals/Agendamento';
import CancelarProposta from '../Modals/CancelarProposta';
import Servicos from '../Modals/Servicos';
import Conclusao from '../Modals/Conclusao';
import ModalLoading from '../../ModalLoading';
import { cores } from '../../../styles/styleUtils';

// Modal ---------------------------------
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '85vw',
  height: '100vh',
  '@media screen and (max-width: 600px)': {
    width: '100vw', // Width de 100% para telas de celulares
    height: '100vh',
  },
  bgcolor: 'background.paper',
  border: `2px solid ${cores.chumbo}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  backgroundColor: cores.branco,
};

const sxFontBotaoMobile = {
  '@media screen and (max-width: 600px)': {
    fontSize: 10,
  },
};

// Modal ---------------------------------

// Stepper ------------------------------------
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: cores.laranja,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: cores.laranja,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : cores.cinzaClaro,
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : cores.cinzaClaro,
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: cores.laranja,
  }),
  '& .QontoStepIcon-completedIcon': {
    color: cores.laranja,
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className="QontoStepIcon-completedIcon" /> : <div className="QontoStepIcon-circle" />}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
};

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : cores.cinzaClaro,
  zIndex: 1,
  color: cores.textoClaro,
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage: `linear-gradient( 136deg, ${cores.laranja} 0%, ${cores.laranjaEscuro} 100%)`,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage: `linear-gradient( 136deg, ${cores.laranja} 0%, ${cores.laranjaEscuro} 100%)`,
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <GroupAddIcon />,
    3: <VideoLabelIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};
// Stepper -----------------------------------

// const emptyProposta = {etapa: {id: 0}}

// ----------------------------------------------------------------------
// eslint-disable-next-line
const Fluxo = React.forwardRef((props, ref) => {
  // const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const [proposta, setProposta] = useState(props.proposta);
  const [anexo, setAnexo] = useState([]);
  const [steps, setSteps] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalMensagem, setModalMensagem] = useState(false);
  const [modalAtividade, setModalAtividade] = useState(false);
  const [modalRejeitar, setModalRejeitar] = useState(false);
  const [modalGarantiaReprovada, setModalGarantiaReprovada] = useState(false);
  const [modalConfirmacaoDelete, setModalConfirmacaoDelete] = useState(false);
  const [modalAddAnexo, setModalAddAnexo] = useState(false);
  const [visualizaProposta, setVisualizaProposta] = useState(false);
  const [modalAddAgenda, setModalAddAgenda] = useState(false);
  const [modalServico, setModalServico] = useState(false);
  const [modalConclusao, setModalConclusao] = useState(false);

  const [fluxogramas, setFluxogramas] = useState([]);

  const fetchData = async () => {
    setModalLoading(true);
    const fetchedFluxos = await getFluxogramas();
    setFluxogramas(fetchedFluxos);
    setSteps(fetchedFluxos.find((fluxo) => fluxo.id === props.proposta.fluxo.id) || null);
    const fetchedAnexos = await await getAnexos(props.proposta);
    setAnexo(fetchedAnexos);
    setModalLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);

  /*
  useEffect(() => {
    fetchFluxos();
  }, [props.proposta]);
  const fetchFluxos = async () => {
    const resultado = await getFluxogramas();
    setFluxogramas(resultado);
  };

  useEffect(() => {
    const fetchAnexos = async () => {
      try {
        const resultado = await getAnexos(props.proposta);
        if (resultado) {
          setAnexo(resultado);
        }
      } catch (error) {
        console.log('Erro ao buscar anexos:', error);
      }
    };
    fetchAnexos();
  }, [props.proposta]);

  useEffect(() => {
    setSteps(fluxogramas.find((fluxo) => fluxo.id === props.proposta.fluxo.id) || null);
  }, [fluxogramas, proposta.fluxo?.id]);
  */

  const onClose = () => {
    setProposta(null);
    setAnexo(null);
    props.onClose();
  };

  const onCloseVisualiza = () => {
    setVisualizaProposta(false);
  };

  const handleConfirm = () => {
    setModalLoading(true)
    const newProposta = { ...proposta };
    newProposta.anexos = anexo;
    props.onConfirm(newProposta);
    onClose();
    setModalLoading(true)
  };

  const handleNext = async () => {
    //
    const resultado = await fluxogramas.find((value) => value.id === proposta.fluxo.id).etapas[proposta.etapa.id + 1];
    if (resultado?.enviamensagem) {
      const { mensagem, destino } = resultado;
      setModalMensagem(true);
      await enviaMensagem(mensagem, destino, proposta, (enviadoComSucesso, mensagem) => {
        setModalMensagem(false);
        if (!enviadoComSucesso) {
          window.alert('Erro ao enviar mensagem');
        }
      });
    }

    if ([50, 51].includes(proposta.fluxo.id) && resultado?.id === 1) {
      setModalAddAgenda(true);
    }

    if ([50, 51].includes(proposta.fluxo.id) && resultado?.nome === 'Concluído') {
      setModalConclusao(true);
    }

    // verifica se é a ultima etapa do ultimo fluxo
    if (
      (proposta.fluxo.id === 50 && proposta.etapa.id === 3) ||
      (proposta.fluxo.id === 51 && proposta.etapa.id === 9)
    ) {
      window.alert('Não encontrado próximo fluxo, não esqueça de salvar');
      return;
    }

    // Backlog---
    const newBacklog = [...proposta.backlog];
    const hasFluxo = newBacklog.find((fluxo) => fluxo.id === proposta.fluxo.id);
    if (hasFluxo) {
      const hasEtapa = hasFluxo.etapas.find((etapa) => etapa.id === proposta.etapa.id);
      if (hasEtapa) {
        hasEtapa.data = new Date();
      } else {
        hasFluxo.etapas.push({
          id: steps.etapas[proposta.etapa?.id].id,
          nome: steps.etapas[proposta.etapa?.id].nome,
          data: new Date(),
        });
      }
    } else {
      const fluxo = fluxogramas.find((fluxo) => fluxo.id === proposta.fluxo.id);
      newBacklog.push({
        id: fluxo.id,
        nome: fluxo.nome,
        etapas: [
          { id: steps.etapas[proposta.etapa?.id].id, nome: steps.etapas[proposta.etapa?.id].nome, data: new Date() },
        ],
      });
    }

    // atualiza proposta
    setProposta({ ...proposta, etapa: steps.etapas[proposta.etapa?.id + 1], backlog: newBacklog });
  };

  const handleBack = () => {
    setProposta({ ...proposta, etapa: steps.etapas[proposta.etapa?.id - 1] });
  };

  const closeModalMensagem = () => {
    setModalMensagem(false);
  };

  const closeModalAtividade = () => {
    setModalAtividade(false);
  };

  const addNewAnexo = (newanexo) => {
    const newArrayAnexos = [...anexo];
    if ('index' in newanexo) {
      const { index, ...restoDoAnexo } = newanexo;
      newArrayAnexos[index] = { ...restoDoAnexo, ...(proposta.fluxo.id === 4 && { instalacao: true }) };
    } else {
      newArrayAnexos.push({ ...newanexo, ...(proposta.fluxo.id === 4 && { instalacao: true }) });
    }

    setAnexo(newArrayAnexos);
    setModalAddAnexo(false);
    setAnexoToChange(null);
  };

  const handleChangeAnexo = (anexo) => {
    setAnexoToChange(anexo);
    setModalAddAnexo(true);
  };

  // Baixar Arquivo Base64 ---------------------
  async function downloadAnexo(anexo) {
    if (anexoToChange !== false) {
      return;
    }
    const anexoResult = await getUnoAnexo({ _id: anexo._id });
    if (anexoResult && anexoResult.base64) {
      const parts = anexoResult.base64.split(',');
      if (parts.length === 2) {
        const contentType = parts[0].split(';')[0];
        const fileType = contentType.split('/')[1];
        const base64String = parts[1];
        const blob = b64toBlob(base64String, fileType);
        let extension = '';
        if (fileType === 'plain') {
          extension = 'txt';
        } else if (fileType === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          extension = 'xlsx';
        } else {
          extension = fileType;
        }
        saveAs(blob, `${anexoResult.nome}.${extension}`);
      }
    }
  }

  function b64toBlob(base64, contentType) {
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  const handleSalvarAtividade = (atividade) => {
    const newArray = [...proposta.atividades];
    newArray.push({ data: new Date(), msg: atividade, ...(proposta.fluxo.id === 4 && { instalacao: true }) });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...proposta, // Use o estado atual como base
      atividades: newArray,
    };
    // Atualize o estado uma vez, após todas as operações terem sido concluídas
    setProposta(updatedProposta);
    closeModalAtividade();
  };

  const garantiaReprovada = (obs) => {
    const newProposta = { ...proposta };
    newProposta.status = 'Reprovada';
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `Garantia reprovada - OBS.: ${obs}`,
    });

    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
      anexos: anexo,
      statusAgenda: 'Finalizada',
    };
    props.onConfirm(updatedProposta);
    onClose();
  };

  const cancelarProposta = (obs) => {
    const newProposta = { ...proposta };
    newProposta.status = 'Cancelada';
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `OS cancelada - OBS.: ${obs}`,
    });

    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
      anexos: anexo,
      statusAgenda: 'Finalizada',
    };
    props.onConfirm(updatedProposta);
    onClose();
  };

  // delete anexo
  const [anexoToDelete, setAnexoToDelete] = useState(null);

  const handleDelete = (anexo) => {
    setAnexoToDelete(anexo);
    setModalConfirmacaoDelete(true);
  };

  const closeModalConfirmacaDelete = () => {
    setAnexoToDelete(null);
    setModalConfirmacaoDelete(false);
  };

  const confirmDeleteAnexo = async () => {
    if (!anexoToDelete._id) {
      const newArray = [...anexo];
      newArray.splice(anexoToDelete.index, 1);
      setAnexo(newArray);
      closeModalConfirmacaDelete();
      return;
    }

    const result = await deleteUnoAnexo(anexoToDelete);
    if (result) {
      closeModalConfirmacaDelete();
      const resultado = await getAnexos(props.proposta);
      if (resultado) {
        setAnexo(resultado);
      }
    }
  };

  // altera anexo
  const [anexoToChange, setAnexoToChange] = useState(false);
  const [newName, setNewName] = useState('');

  const changeName = (event) => {
    setNewName(event.target.value);
  };

  const handleAddAgenda = (formAgendamento) => {
    const newProposta = { ...proposta };
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `Agendamento - Responsável: ${formAgendamento.responsavelExecucao.nome} - Data: ${new Date(
        formAgendamento.dataAgendamento
      ).toLocaleString('pt-BR', {
        timeZone: 'America/Sao_Paulo', // Opcional: força o fuso BR mesmo se o usuário estiver fora
      })}${formAgendamento.statusAgenda ? ` - Status Agenda: ${formAgendamento.statusAgenda}` : ''}`,
    });

    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
      anexos: anexo,
      ...formAgendamento,
      status:
        newProposta.status === 'Atrasada' && new Date(formAgendamento.dataAgendamento) > new Date()
          ? 'Aberta'
          : newProposta.status,
      abriuNotificacao: false,
    };
    props.onConfirm(updatedProposta);
    setModalAddAgenda(false);
  };

  const handleAddServicos = (formServicos) => {
    const newProposta = { ...proposta, ...formServicos };
    props.onConfirm(newProposta);
    setModalServico(false);
  };

  const handleCloseModalAgenda = () => {
    if (!proposta.responsavelExecucao || !proposta.dataAgendamento) {
      setProposta((prev) => ({ ...prev, etapa: steps.etapas[proposta.etapa?.id - 1] }));
    }
    setModalAddAgenda(false);
  };

  const handleConclusao = (formConclusao) => {
    const newProposta = { ...proposta };
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `OS Concluída - Data: ${new Date(formConclusao.dataConclusao).toLocaleString('pt-BR', {
        timeZone: 'America/Sao_Paulo', // Opcional: força o fuso BR mesmo se o usuário estiver fora
      })}`,
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
      anexos: anexo,
      ...formConclusao,
      status: 'Finalizada',
      statusAgenda: 'Finalizada',
    };
    props.onConfirm(updatedProposta);
    setModalAddAgenda(false);
  };

  const handleCloseModalConclusao = () => {
    if (!proposta.dataConclusao) {
      setProposta((prev) => ({ ...prev, etapa: steps.etapas[proposta.etapa?.id - 1] }));
    }
    setModalConclusao(false);
  };

  return (
    <Modal open={props.open} onClose={props.handleClose}>
      <>
        <Box sx={style}>
          <Stack sx={{ width: '100%', backgroundColor: cores.branco }} spacing={4}>
            <Stepper alternativeLabel activeStep={proposta.etapa?.id} connector={<QontoConnector />}>
              {steps?.etapas.map((etapa) => (
                <Step key={etapa.id}>
                  <StepLabel StepIconComponent={QontoStepIcon}>{etapa.nome}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Stack>

          <Stack direction={'row'} gap={2} sx={{ justifyContent: 'space-between', mt: 2, mb: -2 }}>
            <Stack direction={'row'} gap={2} sx={{ justifyContent: 'left', mt: 2, mb: -2 }}>
              {
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<VisibilityIcon />}
                  onClick={() => setVisualizaProposta(true)}
                >
                  Visualizar OS
                </Button>
              }
              {
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<CalendarMonth />}
                  onClick={() => setModalServico(true)}
                >
                  Serviços
                </Button>
              }
              {proposta.etapa.id > 0 && (
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<CalendarMonth />}
                  onClick={() => setModalAddAgenda(true)}
                >
                  Agendamento
                </Button>
              )}
            </Stack>

            <Stack direction={'row'} gap={2} sx={{ justifyContent: 'right', mt: 2, mb: -2 }}>
              {proposta.fluxo.id === 51 && proposta.etapa.id > 0 && (
                <Button
                  size="small"
                  color="error"
                  variant="contained"
                  startIcon={<BlockIcon />}
                  onClick={() => setModalGarantiaReprovada(true)}
                >
                  Garantia Reprovada
                </Button>
              )}

              {
                <Button
                  disabled={proposta.status === 'Cancelada'}
                  color="error"
                  size="small"
                  variant="contained"
                  startIcon={<BlockIcon />}
                  onClick={() => setModalRejeitar(true)}
                >
                  Cancelar OS
                </Button>
              }
            </Stack>
          </Stack>

          <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} flex={1} gap={2}>
            <Stack
              alignItems={'center'}
              sx={{ width: '20%', height: '85%', maxHeight: '80vh', border: 1, borderRadius: 2 }}
            >
              <Stack alignItems={'center'} borderRadius={2} sx={{ backgroundColor: cores.branco, width: '100%' }}>
                <b>Backlog</b>
              </Stack>
              <Box maxHeight="90%">
                <Box
                  maxHeight="100%"
                  height="100%"
                  overflow="auto"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Stepper activeStep={proposta.etapa?.id - 1} orientation="vertical">
                    {proposta.backlog
                      ?.find((fluxo) => fluxo.id === proposta.fluxo.id)
                      ?.etapas?.map((step) => (
                        <Step key={step.id}>
                          <StepLabel>
                            {step.nome}
                            <br />
                            {new Date(step.data).toLocaleDateString()}
                          </StepLabel>
                        </Step>
                      ))}
                  </Stepper>
                </Box>
              </Box>
            </Stack>

            <Stack alignItems={'center'} sx={{ width: '50%', height: '85%', border: 1, borderRadius: 2 }}>
              <Stack
                alignItems={'center'}
                borderRadius={2}
                sx={{ backgroundColor: cores.branco, width: '100%', maxHeight: '80vh' }}
              >
                <b>Atividades</b>
              </Stack>
              <Button sx={{ ...sxFontBotaoMobile, mt: 2 }} variant="contained" onClick={() => setModalAtividade(true)}>
                Adicionar Atividade
              </Button>
              <Container sx={{ height: '55vh', overflowY: 'auto' }}>
                {proposta.atividades?.map((atividade, index) => {
                  return (
                    <Typography
                      key={index}
                      variant="subtitle2"
                      sx={{
                        backgroundColor: cores.branco,
                        width: '100%',
                        borderRadius: 2,
                        mt: 2,
                        '&:hover': { backgroundColor: cores.cinzaClaro, cursor: 'pointer' },
                      }}
                    >
                      {`${new Date(atividade.data).toLocaleDateString()} - `}
                      {atividade.msg.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </Typography>
                  );
                })}
              </Container>
            </Stack>
            <Stack alignItems={'center'} sx={{ width: '30%', height: '85%', border: 1, borderRadius: 2 }}>
              <Stack alignItems={'center'} borderRadius={2} sx={{ backgroundColor: cores.branco, width: '100%' }}>
                <b>Anexos</b>
              </Stack>
              <Stack direction={'row'}>
                <Button
                  sx={{ ...sxFontBotaoMobile, mt: 2, mb: 2 }}
                  size={'small'}
                  onClick={() => setModalAddAnexo(true)}
                  variant="contained"
                >
                  Adicionar Anexo
                </Button>
              </Stack>

              <Container sx={{ height: '55vh', overflowY: 'auto' }}>
                {anexo?.map((anexo, index) => {
                  return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography
                        key={index}
                        onClick={() => downloadAnexo(anexo)}
                        variant="subtitle2"
                        sx={{
                          backgroundColor: cores.branco,
                          ml: 1,
                          mb: 1,
                          '&:hover': {
                            backgroundColor: cores.cinzaClaro,
                            cursor: 'pointer',
                          },
                        }}
                      >
                        {anexoToChange !== index ? (
                          `${index + 1} - ${anexo.nome}`
                        ) : (
                          <TextField
                            size="small"
                            sx={{ '& input': { fontSize: '0.8rem' } }}
                            id="nome"
                            label="Nome"
                            variant="outlined"
                            value={newName}
                            onChange={(e) => changeName(e)}
                          />
                        )}
                      </Typography>
                      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                        <>
                          <IconButton onClick={() => handleDelete({ ...anexo, index })} sx={{ cursor: 'pointer' }}>
                            <DeleteIcon sx={{ fontSize: '20px' }} />
                          </IconButton>
                          <IconButton onClick={() => handleChangeAnexo({ ...anexo, index })} sx={{ cursor: 'pointer' }}>
                            <EditIcon sx={{ fontSize: '20px' }} />
                          </IconButton>
                        </>
                      </div>
                    </div>
                  );
                })}
              </Container>
            </Stack>
          </Stack>

          <Stack direction={'row'} justifyContent={'space-between'} sx={{ bottom: -100, left: 0, right: 0, p: 2 }}>
            <Button sx={sxFontBotaoMobile} size={'small'} variant="outlined" onClick={() => onClose()} color="error">
              {' '}
              Cancelar
            </Button>
            <Button
              sx={sxFontBotaoMobile}
              size={'small'}
              disabled={['Finalizada', 'Cancelada', 'Reprovada'].includes(proposta.status)}
              variant="contained"
              onClick={handleBack}
              startIcon={<ArrowBackIosNewIcon />}
            >
              Anterior
            </Button>
            <Button
              sx={sxFontBotaoMobile}
              size={'small'}
              disabled={['Finalizada', 'Cancelada', 'Reprovada'].includes(proposta.status)}
              variant="contained"
              onClick={handleNext}
              endIcon={<ArrowForwardIosIcon />}
            >
              Próximo
            </Button>
            <Button
              sx={sxFontBotaoMobile}
              size={'small'}
              disabled={['Finalizada', 'Cancelada', 'Reprovada'].includes(proposta.status)}
              variant="outlined"
              color="success"
              onClick={handleConfirm}
              startIcon={<SaveIcon />}
            >
              Salvar
            </Button>
          </Stack>
        </Box>

        {/* Modal Mensagem */}
        {modalMensagem && <ModalMensagem open={modalMensagem} onClose={closeModalMensagem} />}

        {/* Modal Atividade */}
        {modalAtividade && (
          <ModalAtividadade open={modalAtividade} onClose={closeModalAtividade} onConfirm={handleSalvarAtividade} />
        )}

        {/* Modal Visualiza Proposta */}
        {visualizaProposta && (
          <NewOsForm open={visualizaProposta} formData={proposta} handleClose={onCloseVisualiza} visualiza />
        )}

        {modalConfirmacaoDelete && (
          <ModalConfirmacao
            title={'Tem certeza que deseja excluir esse anexo?'}
            open={modalConfirmacaoDelete}
            onClose={closeModalConfirmacaDelete}
            onConfirm={confirmDeleteAnexo}
          />
        )}

        {/* Modal Add Anexo */}
        {modalAddAnexo && (
          <ModalAddAnexo
            open={modalAddAnexo}
            onClose={() => setModalAddAnexo(false)}
            onConfirm={addNewAnexo}
            anexos={anexo}
            tipocontratante={proposta.tipocontratante}
            anexo={anexoToChange}
          />
        )}

        {modalServico && (
          <Servicos
            open={modalServico}
            onClose={() => setModalServico(false)}
            proposta={proposta}
            onConfirm={handleAddServicos}
          />
        )}

        {modalAddAgenda && (
          <Agendamento
            open={modalAddAgenda}
            onClose={handleCloseModalAgenda}
            proposta={proposta}
            onConfirm={handleAddAgenda}
          />
        )}

        {modalConclusao && (
          <Conclusao
            open={modalConclusao}
            onClose={handleCloseModalConclusao}
            proposta={proposta}
            onConfirm={handleConclusao}
          />
        )}
        {/* Modal Rejeitar Proposta */}
        {modalRejeitar && (
          <CancelarProposta open={modalRejeitar} onClose={() => setModalRejeitar(false)} onConfirm={cancelarProposta} />
        )}
        {/* Modal Rejeitar Proposta */}
        {modalGarantiaReprovada && (
          <CancelarProposta
            open={modalGarantiaReprovada}
            onClose={() => setModalGarantiaReprovada(false)}
            onConfirm={garantiaReprovada}
          />
        )}
        {modalLoading && <ModalLoading open={modalLoading} />}
      </>
    </Modal>
  );
});

Fluxo.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,
};

export default Fluxo;